export default __webpack_public_path__ + "static/media/search_icon.163b503b.svg";